module.exports = __webpack_public_path__ + "static/media/5 1 Leseforstaelse Intro.313dd4d0.wav";